export default {
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hello i18n !!"])},
  "errors": {
    "VAS001": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No billing account."])},
    "VAS002": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No merchant id or billing account."])},
    "VAS003": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Billing account is deactive or does not exist."])},
    "VAS004": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Can not get notification settings."])},
    "VAS005": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No Line Notify app id."])}
  }
}